module.exports = __webpack_public_path__ + "static/media/icon_140.4a79a3fb.svg";